import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const Header = () => {
    return (
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark px-3 sticky-top">
            <div className="container-fluid">
                {/* Left Side - Company Name */}
                <a className="navbar-brand" href="#">
                    साई श्रद्धा बहुउद्देशीय विकास संस्था यवतमाळ
                </a>

                {/* Mobile Menu Toggle Button */}
                <button className="navbar-toggler ms-auto" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>

                {/* Right Side - Navigation Links */}
                <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
                    <ul className="navbar-nav">
                        <li className="nav-item"><Link to={"/#home"} className="nav-link">Home</Link></li>
                        <li className="nav-item"><Link to={"/#about"} className="nav-link">About</Link></li>
                        <li className="nav-item"><Link to={"/#service"} className="nav-link" >Service</Link></li>
                        <li className="nav-item"><Link to={"/login"} className="nav-link" >Login</Link></li>
                        <li className="nav-item"><Link to={"/#about"} className="nav-link">Contact</Link></li>
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default Header;